export const algoliaFacetsConfiguration = [
  {
    key: 'categories.en-AU.lvl0',
    type: 'term',
    label: 'Category',
  },
  {
    key: 'categories.en-AU.lvl1',
    type: 'term',
    label: 'Sub Category',
  },
  {
    key: 'categories.en-NZ.lvl0',
    type: 'term',
    label: 'Category',
  },
  {
    key: 'categories.en-NZ.lvl1',
    type: 'term',
    label: 'Sub Category',
  },
  {
    key: 'searchableAttributes.brand',
    type: 'term',
    label: 'Brand',
  },
  {
    key: 'searchableAttributes.product-types',
    type: 'term',
    label: 'Product Type',
  },
  {
    key: 'searchableAttributes.range',
    type: 'term',
    label: 'Range',
  },
  {
    key: 'searchableAttributes.item-material',
    type: 'term',
    label: 'Material',
  },
  {
    key: 'searchableAttributes.colour',
    type: 'term',
    label: 'Colour',
  },
] as const;

const sharedNzFacets = [
  {
    key: 'attributes.IsNZ41121Compliant',
    type: 'term',
    label: 'NZ4121 Accessible',
  },
] as const;

const sharedAuAccessibleFacets = [
  {
    key: 'attributes.IsAS14281Compliant',
    type: 'term',
    label: 'AS1428.1 Accessible',
  },
] as const;

const sanitarywareFacets = [
  { key: 'attributes.pan-height', type: 'term', label: 'Pan Height' },  
  { key: 'attributes.pan-projection-size', type: 'term', label: 'Pan Projection' },
  { key: 'attributes.clean-flush', type: 'term', label: 'Clean Flush' },
  { key: 'attributes.inlet-type', type: 'term', label: 'Inlet Type' },
  { key: 'attributes.trap-type', type: 'term', label: 'Trap Type' },
  { key: 'attributes.wels-with-flow-rate-flush-volume-1', type: 'term', label: 'WELS with Flow Rate Flush Volume 1' },
  { key: 'attributes.IsIndependentLivingCompliant', type: 'term', label: 'Independent Living Compliant' },
] as const;

const sanitarywareAuFacets = [
  { key: 'attributes.IsAS14281Compliant', type: 'term', label: 'AS1428.1 Accessible' },
  { key: 'attributes.IsAS14281Ambulant', type: 'term', label: 'AS1428.1 Ambulant' },
] as const;

const tapwareFacets = [
  { key: 'attributes.wels-with-flow-rate-flush-volume-1', type: 'term', label: 'WELS with Flow Rate' },
  { key: 'attributes.litres-per-minute', type: 'term', label: 'Litres per Minute' },
  { key: 'attributes.coating-method', type: 'term', label: 'Coating Method' },
  { key: 'attributes.outlet-length', type: 'term', label: 'Outlet Length' },
  { key: 'attributes.outlet-type', type: 'term', label: 'Outlet Type' },
  { key: 'attributes.temperature-adjustable', type: 'term', label: 'Temperature Adjustable' },
  { key: 'attributes.flow-adjustable', type: 'term', label: 'Flow Adjustable' },
  { key: 'attributes.cartridge-type', type: 'term', label: 'Cartridge Type' },
  { key: 'attributes.cartidge-size', type: 'term', label: 'Cartridge Size' },
] as const;

const showerFacets = [
  { key: 'attributes.wels-with-flow-rate-flush-volume-1', type: 'term', label: 'WELS with Flow Rate #1' },
  { key: 'attributes.wels-with-flow-rate-flush-volume-2', type: 'term', label: 'WELS with Flow Rate #2' },
  { key: 'attributes.shower-type', type: 'term', label: 'Shower Type' },
  { key: 'attributes.spray-functions', type: 'term', label: 'Spray Function' },
  { key: 'attributes.litres-per-minute', type: 'term', label: 'Litres per Minute' },
  { key: 'attributes.number-of-spray-functions', type: 'term', label: 'Number of Spray Functions' },
  { key: 'attributes.shower-head-diameter', type: 'term', label: 'Shower Head Size' },
  { key: 'attributes.rail-length', type: 'term', label: 'Rail Length' },
  { key: 'attributes.rail-cutdown', type: 'term', label: 'Rail Cutdown' },
  { key: 'attributes.temperature-adjustable', type: 'term', label: 'Temperature Adjustable' },
  { key: 'attributes.flow-adjustable', type: 'term', label: 'Flow Adjustable' },
  { key: 'attributes.is-retrofit', type: 'term', label: 'Retrofit' },
  { key: 'attributes.IsIndependentLivingCompliant', type: 'term', label: 'Independent Living Compliant' },
] as const;

const basinFacets = [
  {key: 'attributes.number-of-tap-holes',type: 'term',label: 'Item Tapholes'},
  {key: 'attributes.overflow',type: 'term',label: 'Overflow'},
  {key: 'attributes.mount-type',type: 'term',label: 'Mount Type'},
  { key: 'attributes.capacity-to-overflow', type: 'term', label: 'Capacity to Overflow' },
  { key: 'attributes.capacity-size', type: 'term', label: 'Capacity Size' },
  { key: 'attributes.shape', type: 'term', label: 'Shape' },
  { key: 'attributes.pedestal-available', type: 'term', label: 'Pedestal Available' },
  { key: 'attributes.IsIndependentLivingCompliant', type: 'term', label: 'Independent Living Compliant' },
] as const;

const kitchenSinksFacets = [
  {key: 'attributes.number-of-tap-holes',type: 'term',label: 'Item Tapholes'},
  {key: 'attributes.overflow',type: 'term',label: 'Overflow'},
  {key: 'attributes.mount-type',type: 'term',label: 'Mount Type'},
  { key: 'attributes.bowl-position', type: 'term', label: 'Bowl Position' },
  { key: 'attributes.capacity-to-overflow', type: 'term', label: 'Capacity to Overflow' },
  { key: 'attributes.drainer', type: 'term', label: 'Drainer' },
  { key: 'attributes.capacity-size', type: 'term', label: 'Capacity Size' },
  { key: 'attributes.IsIndependentLivingCompliant', type: 'term', label: 'Independent Living Compliant' },
] as const;

const laundryTubsFacets = [
  {key: 'attributes.number-of-tap-holes',type: 'term',label: 'Item Tapholes'},
  {key: 'attributes.overflow',type: 'term',label: 'Overflow'},
  {key: 'attributes.mount-type',type: 'term',label: 'Mount Type'},
  { key: 'attributes.bowl-position', type: 'term', label: 'Bowl Position' },
  { key: 'attributes.capacity-to-overflow', type: 'term', label: 'Capacity to Overflow' },
  { key: 'attributes.drainer', type: 'term', label: 'Drainer' },
  { key: 'attributes.capacity-size', type: 'term', label: 'Capacity Size' },
  { key: 'attributes.IsIndependentLivingCompliant', type: 'term', label: 'Independent Living Compliant' },
] as const;

const bathsFacets = [
  { key: 'attributes.shape', type: 'term', label: 'Shape' },
  { key: 'attributes.capacity-size', type: 'term', label: 'Capacity Size' },
  { key: 'attributes.capacity-to-overflow', type: 'term', label: 'Capacity to Overflow' },
] as const;

const bathroomAccessoriesFacets = [
  { key: 'attributes.IsIndependentLivingCompliant', type: 'term', label: 'Independent Living Compliant' },
] as const;

const bathroomAccessoriesAuFacets = [
  { key: 'attributes.IsAS14281Compliant', type: 'term', label: 'AS1428.1 Compliant' },
  { key: 'attributes.IsAS14281Ambulant', type: 'term', label: 'AS1428.1 Ambulant' },
] as const;

const valvesFittingsFacets = [
  { key: 'attributes.wels-with-flow-rate-flush-volume-1', type: 'term', label: 'WELS with Flow Rate' },
  { key: 'attributes.tmv-inlet-type', type: 'term', label: 'TMV Inlet Type' },
  { key: 'attributes.inlet-connection', type: 'term', label: 'Inlet Connection' },
  { key: 'attributes.outlet-connection', type: 'term', label: 'Outlet Connection' },
  { key: 'attributes.nominal-factory-pressure-setting', type: 'term', label: 'Nominal Factory Pressure Setting' },
  { key: 'attributes.nominal-factory-temperature-setting', type: 'term', label: 'Nominal Factory Temperature Setting' },
  { key: 'attributes.valve-type', type: 'term', label: 'Valve Type' },
  { key: 'attributes.maximum-operating-pressure', type: 'term', label: 'Maximum Operating Pressure' },
  { key: 'attributes.maximum-operating-temperature', type: 'term', label: 'Maximum Operating Temperature' },
  { key: 'attributes.minimum-operating-pressure', type: 'term', label: 'Minimum Operating Pressure' },
  { key: 'attributes.minimum-operating-temperature', type: 'term', label: 'Minimum Operating Temperature' },
] as const;

type FacetConfig = { key: string; type: string; label: string };

export const categorySlugsWithSpecificFacets = [
  'sanitaryware',
  'tapware',
  'showers',
  'basins',
  'kitchen-sinks-accessories',
  'laundry-tubs',
  'baths',
  'valves-fittings',
  'bathroom-accessories',
] as const;

export const brandListingSlugs = [
  'caroma',
  'clark',
  'dorf',
  'fowler',
  'stylus',
  'methven',
  'leak-smartshield',
  'tradeready'
] as const;

export function normalizeSlugSegment(segment: string): string {
  return segment.toLowerCase().replace(/'/g, '').replace(/\s+/g, '-');
}

export function isBrandListingSlug(slug?: string): boolean {
  if (!slug) return false;
  return (brandListingSlugs as readonly string[]).includes(normalizeSlugSegment(slug));
}

export function isProductBrandListingPath(slugString: string, categorySlug?: string): boolean {
  const normalizedPath = slugString.toLowerCase();

  const productBrandMatch = normalizedPath.match(/(?:^|\/)product\/([^/]+)\/?$/);
  if (productBrandMatch?.[1] && isBrandListingSlug(productBrandMatch[1])) {
    return true;
  }

  if (categorySlug && isBrandListingSlug(categorySlug)) {
    const segments = normalizedPath.split('/').filter(Boolean);
    if (!segments.includes('product')) {
      return true;
    }
  }

  return false;
}

const categorySlugMatchers: Record<(typeof categorySlugsWithSpecificFacets)[number], string[]> = {
  sanitaryware: ['sanitaryware'],
  tapware: ['tapware'],
  showers: ['showers', 'shower'],
  basins: ['basins', 'basin'],
  'kitchen-sinks-accessories': ['kitchen-sinks-accessories', 'kitchen sinks', 'kitchen sink'],
  'laundry-tubs': ['laundry-tubs', 'laundry tubs', 'laundry tub'],
  baths: ['baths', 'bath'],
  'valves-fittings': ['valves-fittings', 'valves', 'valve', 'fittings', 'fitting'],
  'bathroom-accessories': ['bathroom-accessories', 'bathroom accessories'],
};

export function resolveCategorySlugFromPathSegments(slugSegments: string[]): string | undefined {
  if (!slugSegments.length) return undefined;

  const normalizedSegments = slugSegments.map((segment) =>
    segment.toLowerCase().replace(/'/g, '').replace(/\s+/g, '-'),
  );

  return categorySlugsWithSpecificFacets.find((slug) => normalizedSegments.includes(slug));
}

export function shouldAppendCategoryFacetsForPage(slugString: string, categorySlug?: string): boolean {
  if (categorySlug === 'see-all' || categorySlug === 'search' || categorySlug === 'tradeready') {
    return true;
  }

  const normalizedPath = slugString.toLowerCase();
  if (
    normalizedPath.includes('/brands') ||
    normalizedPath.startsWith('brands') ||
    normalizedPath.includes('/sectors') ||
    normalizedPath.startsWith('sectors')
  ) {
    return true;
  }

  return isProductBrandListingPath(slugString, categorySlug);
}

export function isLimitedFacetListingPage(slugString: string, categorySlug?: string): boolean {
  const normalizedPath = slugString.toLowerCase();
  return (
    normalizedPath.includes('/brands') ||
    normalizedPath.includes('/sectors') ||
    isProductBrandListingPath(slugString, categorySlug)
  );
}

export function resolveCategorySlugFromLabel(label: string): string | undefined {
  const normalized = label
    .split('>')[0]
    .trim()
    .toLowerCase()
    .replace(/'/g, '')
    .replace(/&/g, '')
    .replace(/\s+/g, '-');

  const exactMatch = categorySlugsWithSpecificFacets.find((slug) => slug === normalized);
  if (exactMatch) return exactMatch;

  return categorySlugsWithSpecificFacets.find((slug) =>
    categorySlugMatchers[slug].some(
      (term) => normalized.includes(term.replace(/\s+/g, '-')) || term.replace(/\s+/g, '-').includes(normalized),
    ),
  );
}

export function getCategorySpecificFacets(categorySlug: string, locale?: string): FacetConfig[] {
  switch (categorySlug) {
    case 'sanitaryware':
      return [
        ...sanitarywareFacets,
        ...(locale === 'au' ? sanitarywareAuFacets : []),
        ...(locale === 'nz' ? sharedNzFacets : []),
      ];
    case 'tapware':
      return [
        ...tapwareFacets,
        ...(locale === 'au' ? sharedAuAccessibleFacets : []),
        ...(locale === 'nz' ? sharedNzFacets : []),
      ];
    case 'showers':
      return [
        ...showerFacets,
        ...(locale === 'au' ? sharedAuAccessibleFacets : []),
        ...(locale === 'nz' ? sharedNzFacets : []),
      ];
    case 'basins':
      return [
        ...basinFacets,
        ...(locale === 'au' ? sharedAuAccessibleFacets : []),
        ...(locale === 'nz' ? sharedNzFacets : []),
      ];
    case 'kitchen-sinks-accessories':
      return [
        ...kitchenSinksFacets,
        ...(locale === 'au' ? sharedAuAccessibleFacets : []),
        ...(locale === 'nz' ? sharedNzFacets : []),
      ];
    case 'laundry-tubs':
      return [
        ...laundryTubsFacets,
        ...(locale === 'au' ? sharedAuAccessibleFacets : []),
        ...(locale === 'nz' ? sharedNzFacets : []),
      ];
    case 'baths':
      return [...bathsFacets, ...(locale === 'nz' ? sharedNzFacets : [])];
    case 'valves-fittings':
      return [...valvesFittingsFacets];
    case 'bathroom-accessories':
      return [
        ...bathroomAccessoriesFacets,
        ...(locale === 'au' ? bathroomAccessoriesAuFacets : []),
        ...(locale === 'nz' ? sharedNzFacets : []),
      ];
    default:
      return [];
  }
}

export function getFacetsConfiguration(normalizedSlug: string | undefined, locale?: string): FacetConfig[] {
  switch (normalizedSlug) {
    case 'sanitaryware':
      return [...algoliaFacetsConfiguration, ...getCategorySpecificFacets('sanitaryware', locale)];
    case 'tapware':
      return [...algoliaFacetsConfiguration, ...getCategorySpecificFacets('tapware', locale)];
    case 'showers':
      return [...algoliaFacetsConfiguration, ...getCategorySpecificFacets('showers', locale)];
    case 'basins':
      return [...algoliaFacetsConfiguration, ...getCategorySpecificFacets('basins', locale)];
    case 'kitchen-sinks-accessories':
      return [...algoliaFacetsConfiguration, ...getCategorySpecificFacets('kitchen-sinks-accessories', locale)];
    case 'laundry-tubs':
      return [...algoliaFacetsConfiguration, ...getCategorySpecificFacets('laundry-tubs', locale)];
    case 'baths':
      return [...algoliaFacetsConfiguration, ...getCategorySpecificFacets('baths', locale)];
    case 'valves-fittings':
      return [...algoliaFacetsConfiguration, ...getCategorySpecificFacets('valves-fittings', locale)];
    case 'bathroom-accessories':
      return [...algoliaFacetsConfiguration, ...getCategorySpecificFacets('bathroom-accessories', locale)];
    default:
      return [...algoliaFacetsConfiguration];
  }
}

export function appendCategoryFacetsForSelections(
  baseFacets: readonly FacetConfig[],
  selectedCategoryLabels: string[],
  locale?: string,
): FacetConfig[] {
  const categorySlugs = selectedCategoryLabels
    .map(resolveCategorySlugFromLabel)
    .filter((slug): slug is string => Boolean(slug));

  if (categorySlugs.length === 0) {
    return [...baseFacets];
  }

  const existingKeys = new Set(baseFacets.map((facet) => facet.key));
  const additionalFacets: FacetConfig[] = [];

  categorySlugs.forEach((slug) => {
    getCategorySpecificFacets(slug, locale).forEach((facet) => {
      if (!existingKeys.has(facet.key)) {
        existingKeys.add(facet.key);
        additionalFacets.push(facet);
      }
    });
  });

  return [...baseFacets, ...additionalFacets];
}